import type { CurrentEvent, EventVenueRow } from "@/containers/events/types";

export function getEventVenues(currentEvent?: CurrentEvent | null): EventVenueRow[] {
  return currentEvent?.venues ?? [];
}

export function getJamanVenueChoices(currentEvent?: CurrentEvent | null) {
  return getEventVenues(currentEvent)
    .filter((v) => v.role === "JAMAN")
    .map((v) => ({ id: v.code, name: v.label }));
}

export function getNamaazVenueChoices(currentEvent?: CurrentEvent | null) {
  return getEventVenues(currentEvent)
    .filter((v) => v.role === "NAMAAZ")
    .map((v) => ({ id: v.code, name: v.label }));
}

export function getAsharaVenueChoices(currentEvent?: CurrentEvent | null) {
  const jaman = getJamanVenueChoices(currentEvent);
  if (jaman.length > 0) {
    return jaman;
  }
  return getEventVenues(currentEvent).map((v) => ({ id: v.code, name: v.label }));
}

export function getVenueTabCodes(
  currentEvent: CurrentEvent | null | undefined,
  role: "JAMAN" | "NAMAAZ"
): string[] {
  const venues = getEventVenues(currentEvent).filter((v) => v.role === role);
  if (venues.length > 0) {
    return venues.map((v) => v.code);
  }
  return [];
}

export function formatVenueLabel(code: unknown, currentEvent?: CurrentEvent | null): string {
  if (code == null || code === "") return "—";
  const match = getEventVenues(currentEvent).find((v) => v.code === String(code));
  return match?.label ?? String(code);
}

export function venueHelperText(currentEvent?: CurrentEvent | null): string {
  const labels = getEventVenues(currentEvent).map((v) => v.label);
  if (labels.length === 0) {
    return "Configure venues on the event before registering niyaaz.";
  }
  return `Select any one of ${labels.join(", ")}`;
}
